<template>
    <div class="informationBox">
        <div class="information">
            <div class="messageTitle">个人信息</div>
            <h4 style="margin: 20px;color: #409EFF">可用余额：{{keyong_money}}元</h4>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="真实姓名" prop="real_name">
                    <el-input v-model="ruleForm.real_name" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="ruleForm.phone" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idcardnum">
                    <el-input v-model="ruleForm.idcardnum" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="企业名称" prop="company_name">
                    <el-input v-model="ruleForm.company_name" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="到期日" v-if="ruleForm.end_time!=''">
                    <el-input v-model="ruleForm.end_time" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="gender">
                    <el-radio v-model="ruleForm.gender" label="1">男</el-radio>
                    <el-radio v-model="ruleForm.gender" label="2">女</el-radio>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="ruleForm.email"></el-input>
                </el-form-item>
                <el-form-item label="民族" prop="nation">
                    <el-input v-model="ruleForm.nation"></el-input>
                </el-form-item>
                <el-form-item label="所在省份"  :rules="[{ required: true }]">
                    <el-select  v-model="ruleForm.provinceValue" placeholder="请选择所在省份" @change="refreshData">
                        <el-option
                                v-for="item in options"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="住址" prop="address">
                    <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
            </el-form>
             <div class="amend" @click="amend">
                 修改
             </div>
        </div>
    </div>
</template>

<script>
    import { getProvinces, modifyInformation, personalDetails } from '../../api/personal';

    export default {
        name: "personal",
        data(){
            return{
                province:'',
                options:[], //省份数组
                ruleForm:{
                    phone:'',
                    email:'',
                    nation:'',
                    gender:'',
                    address:'',
                    real_name:'',
                    company_name:'',
                    idcardnum:'',
                    provinceValue:'',
                },
                keyong_money:'',
                rules: {
                    real_name:[
                        {required: true}
                    ],
                    idcardnum:[
                        {required: true}
                    ],
                    gender:[
                        {required: true}
                    ],
                    email: [
                        {required: true},
                        {  message: '请输入邮箱地址', trigger: 'blur' },
                        {
                            type: 'email',
                            message: '请输入正确的邮箱地址',
                            trigger: ['blur', 'change'],
                        },
                    ],
                    provinceCheck:[
                        {
                            required:true,
                        }
                    ],
                    nation:[
                        {required: true},
                    ],
                    address:[
                        {required: true},
                    ]

                }
            }
        },
        methods:{
            amend(){
                modifyInformation(this.ruleForm.gender,this.ruleForm.email,this.ruleForm.nation,this.ruleForm.address,this.ruleForm.provinceValue).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            refreshData (val) {
                this.$forceUpdate()
            }
        },
        created() {
            personalDetails().then(res=>{
                this.ruleForm.real_name=res.data.real_name
                this.ruleForm.phone=res.data.username
                this.ruleForm.idcardnum=res.data.idcardnum
                this.ruleForm.company_name=res.data.company_name
                this.ruleForm.end_time=res.data.end_time
                this.ruleForm.gender=res.data.gender.toString()
                this.ruleForm.email=res.data.email
                this.ruleForm.nation=res.data.nation
                this.ruleForm.address=res.data.address
                this.ruleForm.provinceValue=res.data.sheng_code
                this.province=res.data.sheng_name
                this.keyong_money=res.data.keyong_money
            })
            getProvinces().then(res=>{
                if (res.code==200){
                    this.options=res.data.list
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    }
</script>

<style scoped>
    .informationBox{
        width: 100%;
        height: 93vh;
        overflow-y: scroll;
        margin: 0 auto;
    }
    .information{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
        margin: 10px;
    }
    .messageTitle{
        margin-bottom: 20px;
    }
    ::v-deep .el-input{
        width: 30%;
    }
    .amend{
        height: 35px;
        width: 80px;
        border-radius: 5px;
        line-height: 35px;
        text-align: center;
        background-color: #3e62f6;
        color: #fff;
        margin:  auto;
        cursor: pointer;
    }
    ::v-deep .el-select>.el-input{
        width: 100%;
    }
</style>
